var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "upload-file"
  }, [_vm.row ? _c('b-modal', {
    attrs: {
      "id": "repInfoRequestDetailModal",
      "centered": "",
      "size": "xl",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "repInfoRequestDetailModal-header text-center"
        }, [_c('h4', [_vm._v("Information Change Detail")]), _c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }], null, false, 495756242)
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "repInfoRequestDetailModal-form"
  }, [_c('div', {
    staticClass: "repInfoRequestDetailModal-form"
  }, [_c('div', {
    staticClass: "info-wrap-req"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "mb-0 me-2 info-detail"
  }, [_vm._v(" " + _vm._s(_vm.row.user_info.name) + " ")]), _c('div', {
    staticClass: "tier-tag"
  }, [_vm._v(" " + _vm._s(_vm.row.type_name) + " ")])]), _c('div', {
    staticClass: "info-detail mb-2 pb-1 mt-1"
  }, [_vm._v(" System Id : " + _vm._s(_vm.row.policy_id) + " ")]), _c('div', {
    staticClass: "info-detail"
  }, [_vm._v("Card Request : " + _vm._s(_vm.row.cards_requested))]), _c('div', {
    class: ['status', _vm.row.status_name ? _vm.row.status_name.toLowerCase().replace(/ /g, '-') : '']
  }, [_vm._v(" " + _vm._s(_vm.row.status_name) + " ")]), _c('div', {
    staticClass: "row mt-4"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "info-detail"
  }, [_vm._v("Information")]), _c('div', {}, [_vm._v(_vm._s(_vm.row.information))])]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "info-detail"
  }, [_vm._v("Reason")]), _c('div', {}, [_vm._v(_vm._s(_vm.reason))])])])]), _c('div', {
    staticClass: "payment mt-4"
  }, [_c('div', {
    staticClass: "info-detail"
  }, [_vm._v("Payment Details")]), _c('div', {
    staticClass: "page-card p-0 mt-2 table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("S.N")]), _c('th', [_vm._v("Card Id")]), _c('th', [_vm._v("Payer Id")]), _c('th', [_vm._v("Amount")]), _c('th', [_vm._v("Payment ID")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Description")]), _c('th', [_vm._v("Clearing Date")]), _c('th', [_vm._v("Invoice ID")])])]), _c('tbody', [_vm.row.repInfoPaymentDetails && _vm.row.repInfoPaymentDetails.length > 0 ? _vm._l(_vm.row.repInfoPaymentDetails, function (item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(++index))]), _c('td', [_vm._v(_vm._s(item.card_id))]), _c('td', [_vm._v(_vm._s(item.payer_id))]), _c('td', [_vm._v("$" + _vm._s(item.amount))]), _c('td', [_vm._v(_vm._s(item.payment_id))]), _c('td', {
      staticClass: "text-capitalize"
    }, [_vm._v(_vm._s(item.status))]), _c('td', [_vm._v(_vm._s(item.payment_description))]), _c('td', [_vm._v(_vm._s(item.clearing_date))]), _c('td', [_vm._v(_vm._s(item.invoice_id))])]);
  }) : [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("No records found.")])])]], 2)])])])])])])], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }